import { getJson } from '@/utils/fetchOptions';

import { useAuthToken } from './useAuth';
import { useQuery } from './useQuery';

type UseTeamGetResponse = {
  teams: Api.Team[];
} & { brands: Api.Brand[] } & { members: Api.Member[] };

export function useTeamGet(currentTeamId?: string) {
  const token = useAuthToken();

  const {
    isLoading,
    data = {},
    error
  } = useQuery({
    queryKey: 'team-get',
    queryData: currentTeamId,
    queryFn: async () =>
      getJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/teams/search`,
        token
      }).then(async (response: { teams: Api.Team[] } | ResponseObject) => {
        if ('teams' in response) {
          const currentTeam = response.teams.find((team) => team.team_id === currentTeamId);

          if (currentTeam) {
            let members: Api.Member[] = [];
            let brands: Api.Brand[] = [];

            await getJson({
              url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/team/${currentTeam.team_id}/members/search`,
              token
            }).then((memberData: { members: Api.Member[] }) => {
              if ('members' in memberData) {
                members = memberData.members;
              }
            });

            await getJson({
              url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/team/${currentTeam.team_id}/brands/search`,
              token
            }).then((brandData: { brands: Api.Brand[] }) => {
              if ('brands' in brandData) {
                brands = brandData.brands;
              }
            });

            return {
              teams: response.teams,
              members,
              brands
            };
          }
          return response;
        }
        return response;
      }),
    enabled: !!token && !!currentTeamId
  });

  return {
    isLoading,
    error,
    data: data as UseTeamGetResponse
  };
}
